/**
 * Community API base URL. The literal `process.env.PUBLIC_API_URL` is replaced
 * with a string at bundle time by Bun's `PUBLIC_*` env-inlining (dev-server.js
 * for the dev server, build.js for production). The `PUBLIC_` prefix is the
 * inlining allowlist; only literal `process.env.PUBLIC_*` reads are replaced, so
 * do not destructure or alias it.
 *
 * The SPA and the API are different hosts — never use window.location.origin.
 */
export function getBackendUrl() {
    return process.env.PUBLIC_API_URL || '';
}
